type BreakPoints = {
  desktop: string;
  desktopBig: string;
  tablet: string;
  tabletBig: string;
  mobile: string;
  mobileBig: string;
  ie10plus: string;
};

export const BREAK_POINT_WIDTH_DESKTOP = 1024;
export const BREAK_POINT_WIDTH_DESKTOP_BIG = 1200;
export const BREAK_POINT_WIDTH_TABLET_BIG = 900;
export const BREAK_POINT_WIDTH_TABLET = 768;
export const BREAK_POINT_WIDTH_MOBILE_BIG = 481;

const BREAK_POINTS: BreakPoints = {
  desktop: `(min-width: ${BREAK_POINT_WIDTH_DESKTOP}px)`,
  desktopBig: `(min-width: ${BREAK_POINT_WIDTH_DESKTOP_BIG}px)`,
  tabletBig: `(min-width: ${BREAK_POINT_WIDTH_TABLET_BIG}px)`,
  tablet: `(min-width: ${BREAK_POINT_WIDTH_TABLET}px)`,
  mobileBig: `(min-width: ${BREAK_POINT_WIDTH_MOBILE_BIG}px)`,
  mobile: `(min-width: 0px)`,
  ie10plus: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
};

export default BREAK_POINTS;



// WEBPACK FOOTER //
// ./packages/smart-home-support/styling/media-queries.ts